/**
 * Reactive auth state using Vue 3 reactivity.
 * State is readonly externally; mutations are the only write path.
 */
import { reactive, readonly } from 'vue'

const state = reactive({
  isAuthenticated: false,
  isLoading: true,
  user: null,
  activeTenant: null,
  availableTenants: [],
  permissions: [],
  requiresTenantSelection: false,
  error: null
})

export const authState = readonly(state)

export const authMutations = {
  setLoading(loading) {
    state.isLoading = loading
  },

  setUser(authData) {
    if (!authData) {
      this.reset()
      return
    }
    state.isAuthenticated = true
    state.user = authData.user
    state.availableTenants = authData.availableTenants || []
    state.requiresTenantSelection = authData.requiresTenantSelection || false
    state.error = null
  },

  setActiveTenant(tenant) {
    state.activeTenant = tenant
    state.requiresTenantSelection = false
  },

  setPermissions(permissions) {
    state.permissions = permissions || []
  },

  setError(error) {
    state.error = error
  },

  clearError() {
    state.error = null
  },

  reset() {
    state.isAuthenticated = false
    state.isLoading = false
    state.user = null
    state.activeTenant = null
    state.availableTenants = []
    state.permissions = []
    state.requiresTenantSelection = false
    state.error = null
  }
}
